export const settings = {
  selector: '.js-sibling-navigation',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const selectedItem = element.querySelector( '.current_page_item' )
  // Get the selected item visible.
  if ( selectedItem ) {
    element.scrollLeft = selectedItem.offsetLeft - 40
  }
}
